@if (editTeamMemberForm && businessRoles) {
  <div [formGroup]="editTeamMemberForm" class="team-member-dialog-container">
    <div class="hub-dialog-header">
      <h5>
        {{teamMember ? 'Edit Team Member' : 'Add Team Member'}}
      </h5>
    </div>
    <mat-dialog-content class="hub-custom-scrollbar">
      <div class="hub-team-member-dialog content">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <div class="dialog-label">{{teamMember ? 'Team Member' : 'Select Team Member'}}
                  <app-help-selector [selector]="1170"></app-help-selector>
                </div>
                @if (!teamMember) {
                  @if (!isFinanceContactRoleSelected) {
                    <div class="hub-select-container">
                      <mat-form-field>
                        <input type="text" matInput [formControl]="userTypeahead"
                          [matAutocomplete]="auto" placeholder="Type User Name">
                      </mat-form-field>
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser"
                        (optionSelected)="user_clicked($event)">
                        @for (user of filteredUsers$ | async; track user) {
                          <mat-option [value]="user"
                            [disabled]="isUserDisabled(user)">
                            {{user.fullName}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </div>
                  }
                } @else {
                  <div>
                    {{teamMember.user.fullName}}
                  </div>
                }
                @if (selectedUser) {
                  <div>
                    <div>{{selectedUser.businessUnit?.name}}</div>
                    <div class="text-muted">{{selectedUser.businessUnit?.division?.name}}</div>
                  </div>
                }
                <div class="hub-validation-error-message employee-error">
                  {{getEmployeeValidationMessage()}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <div class="dialog-label">Choose Role(s) for Team Member <app-help-selector
                  [selector]="1169">
                </app-help-selector>
              </div>
              <div class="role-list" formArrayName="selectedBusinessRoles">
                @for (roleGroup of selectableBusinessRoles.controls; track roleGroup; let i = $index) {
                  <div>
                    <div [formGroupName]="i">
                      <div [matTooltip]="getRoleTooltip(roleGroup.value)" matTooltipPosition="left"
                        matTooltipShowDelay="300" matTooltipHideDelay="200">
                        <mat-checkbox color="primary" formControlName="isSelected">
                          {{roleGroup.value.businessRole.name}}
                          @if (roleGroup.value.businessRole.isSingleUserPerProject) {
                            <span
                            class="one-user-warning">(limit 1 user)</span>
                          }
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="text-warning team-member-warning">
                      <div [innerHTML]="getRoleWarningText(roleGroup.value)"></div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="hub-validation-error-message roles-error">
          {{getRolesValidationMessage()}}
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <div class="hub-modal-footer-text">
    <button (click)="cancel()" class="cancel-button mr-1 legitRipple">Cancel</button>
    @if (teamMember) {
      <button (click)="submitTeamMember()" class="hub-icon-button"
        [disabled]="editTeamMemberForm.invalid || editTeamMemberForm.pristine">
        <b><i class="icon-checkmark3"></i></b>
        Done
      </button>
    }
    @if (!teamMember) {
      <button (click)="submitTeamMember()" class="hub-icon-button"
        [disabled]="!editTeamMemberForm.valid">
        <b><i class="icon-plus-circle2"></i></b>
        Add to Team
      </button>
    }
  </div>
</div>
}
